import { useLocation } from "react-router-dom";
import { UserOutlineSvg, ShashiLogo } from "../../../icons";

const Header = () => {
  const location = useLocation();
  return (
    <>
      {location.pathname.includes("shashiunplugged") ? null : (
        <header
          className="w-full h-[60px] flex justify-center items-center bg-white z-50 fixed top-0"
        >
          <ShashiLogo />
        </header>
      )}
    </>
  );
};

export default Header;
